import { combineReducers } from 'redux'

import escolaridadeCurriculos from './escolaridadeCurriculos'

export default combineReducers({ escolaridadeCurriculos })
